<template>
  <div class="page">
    <div class="page-content">
      <div class="layoutTop"/>

      <div class="container-fluid">
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <div class="panel21 panel-default float-none">

              <div class="panel-heading">
                <h4 class="content-block labelAccordionForm">
                  <img src="../../assets/static/images/icons/gearwheels.png" class="formIcon"/>
                  {{ $t('rights.rights') }}
                </h4>
              </div>
              <rights-list class="pl-4"
                :userID="parseInt($engine.user.get().id)"
                :userRights="userRights"
                isMyRightsPage
                :key="$engine.user.get().id"></rights-list>

          </div>

          <div class="row" v-if="isChangeable()">
            <div class="col-md-3 offset-md-9">
              <button round
                class="milkyBlockBlack button-action firstButtonMarginTop"
                @click="changeApplicationSettings">
                <i class="icon fa fa-save"></i>
                <span>{{ $t('common.sve') }}</span>
              </button>
              <div class="toolbarPageBottomBlank"></div>
            </div>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col-md-2 offset-md-7">
          <div class="toolbarPageBottomBlank"></div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>

// import rightsData2 from '@/pages/user/data/rightsData2.json'
import rightsList from '@/components/rights/rightsList.vue'

export default {
  components: {
    'rights-list': rightsList
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      userID: 0,
      userRights: {},
      savedRights: {}
    }
  },
  created () {
    let that = this
    if (this.$engine.user.get().id === this.$engine.user.get().userAccountId) {
      this.$engine.rights.getAdminRights().then(resp => {
        that.userRights = that.$R.clone(resp.rights)
        that.savedRights = that.$R.clone(resp.rights)
      })
    } else {
      this.$engine.rights.getPersonnalRights().then(resp => {
        that.userRights = that.$R.clone(resp.rights)
        that.savedRights = that.$R.clone(resp.rights)
      })
    }
  },
  mounted () {
    if (!this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.$$('.accordionForm').addClass('accordion-item-expanded')
      this.$$('.formChevron').transform('rotate(90deg)')
    }
  },
  methods: {
    rotateChevron ($event) {
      if (this.Dom7($event.target).parent().parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().hasClass('accordion-item-expanded')) {
        this.Dom7($event.target).find('i').transform('rotate(0deg)')
      } else {
        this.Dom7($event.target).find('i').transform('rotate(90deg)')
      }
    },
    isChangeable () {
      return this.$engine.user.get().id === this.$engine.user.get().userAccountId
    },
    changeApplicationSettings () {
      let that = this
      let addedRights = []
      let removedRights = []
      for (const right in this.userRights) {
        if (this.userRights[right] &&
          this.savedRights[right] &&
          this.userRights[right].state !== this.savedRights[right].state) {
          if (this.userRights[right].state === '1') {
            addedRights.push(right)
          } else {
            removedRights.push(right)
          }
        }
      }
      if (addedRights.length === 0 && removedRights.length === 0) {
        this.$f7.alert('', this.$t('errors.no_right_modified'))
        return
      }
      if (this.$engine.user.get().id === this.$engine.user.get().idProfile) {
        this.$engine.rights.editAdminRights(addedRights, removedRights)
        .then(resp => {
          that.$f7.alert('', that.$t('rights.rights_edited'))
        })
        .catch(err => {
          console.log(err)
        })
      } else {
        this.$engine.rights.editAdminRights(addedRights, removedRights)
        .then(resp => {
          that.$f7.alert('', this.$t('rights.rights_edited'))
          // alert(this.$t('rights.rights_edited'))
          window.location.reload()
        })
        .catch(err => {
          console.log(err)
        })
      }
    }
  }
}
</script>
<style scoped>
.subOption {
  font-size: 14px;
}
.subOption input::-webkit-input-placeholder {
  font-size: 14px;
}

.label-switch {
  float: right;
}

.no-bullets {
    list-style-type: none;
}
.mt-2 {
  width: 100%;
}
.inputFileButton {
  float: left;
}
.list-block {
    padding: 0px 0px 0px 0px;
    margin: auto;
    width: 100%
}

.button-setting {
  width: 80px;
}
ul {
  margin-left: -35px;
}
</style>
